import Flex from "components/common/Flex";
import { Spinner } from "react-bootstrap";

const ItemsLoading1=({message,animation ,size})=>{
    return (
      <Flex>
        <Spinner animation={animation} size={size} />
        <p style={{ marginLeft: '5px' }}> {message}</p>
      </Flex>
    ); 

}

export default ItemsLoading1;